import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AccountType } from 'models';

@Injectable({
	providedIn: 'root',
})
export class AccountTypeService {
	constructor(private http: HttpClient) {}

	public get(): Observable<AccountType[]> {
		return this.http.get<AccountType[]>('api/accounttype/get');
	}
}
